var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('img',{staticClass:"bg",attrs:{"src":_vm.imageUrl}}),_c('div',{staticClass:"fixed-btn"},[_c('div',{staticClass:"btn",on:{"click":_vm.saveImage}},[_vm._v("保存客服二维码")])])])}
var staticRenderFns = []

export { render, staticRenderFns }